<small
  *ngIf="formCtrl.errors?.maxlength && (formCtrl.dirty || formCtrl.touched)"
  class="p-invalid"
>
  {{ errorMsg }}
</small>
